import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function HashRedirectHandler() {
  const navigate = useNavigate()

  useEffect(() => {
    const handle = () => {
      const hash = window.location.hash
      if (hash.startsWith('#/')) {
        const path = hash.slice(1) // remove '#'
        // avoid infinite loops
        if (window.location.pathname !== path) {
          navigate(path, { replace: true })
        }
      }
    }

    // handle initial load + subsequent changes
    handle()
    window.addEventListener('hashchange', handle)
    return () => window.removeEventListener('hashchange', handle)
  }, [navigate])

  return null
}